import React from 'react';
import {gql} from '@apollo/client';
import {get, uniqBy} from 'lodash';

import client from '../../../src/graphql/client';
import refactorFinanceRates from '../../../src/data-restructure/data/repayment-calc-rates';
import financeRatesQuery from '../../../src/graphql/queries/finance-rates';
import ForSaleContainer from '../../../src/containers/ForSale';
import contentBuilderQuery from '../../../src/graphql/queries/content-builder';
import refactorContentBuilderData from '../../../src/data-restructure/contentBuilder';
import toTitleCase from '../../../src/util/toTitleCase';
import stockPageCalcQuery from '../../../src/graphql/queries/pages/stock-page-calc';
import stockCalcRestructure from '../../../src/data-restructure/pages/stock-calc';

// queries
import seoQuery from '../../../src/graphql/queries/seo';

const ForSale = (props) => {
  return (
    <ForSaleContainer 
      {...props}
    />
  )
}

export default ForSale;

export async function getStaticPaths() {

  if (process.env.DEALER_SITE) {
    return { paths: [], fallback: 'blocking' }
  }
  
  const GET_DYNAMIC_PATHS_QUERY = gql`
    query GET_DYNAMIC_PATHS {
      stockPages(first: 10000) {
        nodes {
          acf_stock_page {
            range
            region
            state
          }
        }
      }
    }
  `

  const result = await client.query({
    query: GET_DYNAMIC_PATHS_QUERY
  });

  const ranges = get(result, 'data.stockPages.nodes', []);
  let paths = [];
  
  const filteredRanges = ranges.filter((item) => {
    // filter out if doesn't have uri
    return (item.acf_stock_page.range)
  });
  
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  const domain = countryCode === 'au' ? 'jayco.com.au' : 'jayco.co.nz';

  filteredRanges.forEach(range => {
    const assignedDomains = ['jayco.com.au'] // Aus only
    assignedDomains.indexOf(domain) !== -1 && paths.push({
      params: {
        range: `${range.acf_stock_page.range.replace(' ', '-')}`
      }
    });
  })

  return { paths , fallback: 'blocking' }
}


export async function getStaticProps(context) {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  
  const {
    params
  } = context

  const GET_DYNAMIC_RANGE_PROPS = gql`
    query GET_RANGE_DATA($uri: String) {
      stockPages(first: 10000) {
        nodes {
          id
          title
          seo {
            ${seoQuery}
          }
          acf_domains {
            assignedDomains
          }
          acf_stock_page {
            range
            offRoad
            state
            region
            postcodes
          }
          ${contentBuilderQuery('StockPage_AcfContentBuilder')}
        }
      }
      ${financeRatesQuery}
      ${stockPageCalcQuery('au')}
    }
  `
  const pageData = await client.query({
    query: GET_DYNAMIC_RANGE_PROPS,
    // variables: {
    //   uri: params.range
    // }
  });

  const calculatorModal = stockCalcRestructure(get(pageData, 'data', []));

  const pageProps = get(pageData, 'data.stockPages.nodes', []).find(item => {
    return !get(item, 'acf_stock_page.region', null) && !get(item, 'acf_stock_page.state', null) && get(item, 'acf_stock_page.range', '').replace(' ', '-').toLowerCase() === params.range.replace(' ', '-').toLowerCase() && get(item, 'acf_stock_page.range', null)
  });

  const locations = get(pageData, 'data.stockPages.nodes', []).map(location => {
    return {
      region: get(location, 'acf_stock_page.region', null),
      state: get(location, 'acf_stock_page.state', null),
      postcodes: get(location, 'acf_stock_page.postcodes', null) ? get(location, 'acf_stock_page.postcodes', '').replace(/ /g,'').split(',') : []
    };
  })

  const categories = uniqBy(get(pageData, 'data.stockPages.nodes', []).map(cat => {
    return get(cat, 'acf_stock_page.range', null)
  }))

  // seo
  const title = get(pageProps, 'title', null);
  const seo = get(pageProps, 'seo', null);
  const assignedDomains = ['jayco.com.au'] // get(pageProps, 'data.acf_domains.assignedDomains', []); 

  const meta = {
    title,
    seo,
    assignedDomains
  };

  const rates = refactorFinanceRates(pageData, countryCode);
  
  const cbData = pageProps ? await refactorContentBuilderData(pageProps, null, 'StockPage') : null;

  const breadcrumbs = {
    list: [
      {
        link: {
            title: 'Home',
            href: '/',
            target: '_self',
            assignedDomains
        },
        active: false
      },
      {
        link: {
            title: 'Search',
            href: '/for-sale',
            target: '_self',
            assignedDomains
        },
        active: false
      },
      {
        link: {
            title: `${toTitleCase(params.range.replace('-', ' '))} for Sale`,
            href: `/for-sale/${params.range}`,
            target: '_self',
            assignedDomains
        },
        active: true
      }
    ]
  };

  //console.log('JerryTest');
  //console.dir(breadcrumbs, {depth: null});

  return {
    revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
    props: {
      meta,
      title: `[range] for sale in Australia`,
      range: params.range.replace('-', ' '),
      rates,
      categories,
      // locations, // Too large - use json file instead
      contentBuilder: cbData,
      breadcrumbs,
      footerDisclaimer: rates.disclaimer,
      calculatorModal
      // pageData,
      // pageProps: pageProps ? pageProps : null,
      // pageProps
    }
  }
}
